import React from 'react';

import { cn } from '@/utils/cn';

interface BaseSkeletonProps extends React.ComponentPropsWithoutRef<'div'> {
  animate?: boolean;
}

const BaseSkeleton = ({ className }: BaseSkeletonProps) => {
  return <div className={cn('w-full rounded-md bg-[#F5F5F5]', className)} />;
};

export default BaseSkeleton;
